import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import { formatSerialFormatterForDisplay } from '#/modules/imsMgmt/settings/mtrTemplate/helper/serialFormatterSerialize';

export const mtrTemplateSideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      {
        label: '序號格式',
        value: (row) => formatSerialFormatterForDisplay(row?.serialFormatter),
      },
      {
        label: '主分類',
        value: (row) => row?.mtrStructMain?.name ?? '-',
      },
      {
        label: '次分類',
        value: (row) => row?.mtrStructSub?.name ?? '-',
      },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: 'remark' },
    ],
  },
];
